import React from "react";

import { templates } from "@reactivated";

// This template is only used by tsi-stearns, which overrides it in
// client/templates/StearnsRetailLocatorBlockTemplate.tsx. Other sites re-export
// this placeholder to satisfy Reactivated's generated imports.
/** @public */
export const Template = (
    _props: templates.StearnsRetailLocatorBlockTemplate,
): React.JSX.Element => {
    return <></>;
};
